import Table from "../../../models/table";

export default class GetTablesResponse {
    tables: Array<Table>;

    constructor(json: any) {
        this.tables = json.map((x: any) => new Table(x));
    }
}